// extracted by mini-css-extract-plugin
export var component = "PageGrid-module--component--K1TXd";
export var fullWidth = "PageGrid-module--fullWidth--j7J35";
export var group = "PageGrid-module--group--2usfB";
export var item = "PageGrid-module--item--QmXdY";
export var layout = "PageGrid-module--layout--rqFAm";
export var section = "PageGrid-module--section--K1ulS";